module.exports = __webpack_public_path__ + "Viasatgolf-cf06747623eb36f946fcb853ade5e798.png";


//////////////////
// WEBPACK FOOTER
// ./assets/logos/Viasatgolf.png
// module id = 1152
// module chunks = 0 1